import { TextField } from '@fox/atoms';
import { FormRenderMode, QuestionStyleTypes, useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context';
import { QuestionBlockMetadata, QuestionDisplayType, TextDisplayTypes } from '../contracts';

type IRenderTextQuestionProps = {
	inEditMode: boolean;
	questionName: string;
	id: string;
	placeholder?: string;
	displayType?: QuestionDisplayType;
	maxLength?: QuestionBlockMetadata['maxLength'];
};

export const RenderTextQuestion = (props: IRenderTextQuestionProps) => {
	const { inEditMode, questionName, id, displayType, placeholder, maxLength } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();

	const answerString = getAnswer(questionName)?.answer?.answerString ?? '';

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);

	let textFieldProps;
	switch (displayType) {
		case TextDisplayTypes.singleLine:
			textFieldProps = {
				size: 'small'
			};
			break;

		case TextDisplayTypes.textArea:
		default:
			textFieldProps = {
				size: 'medium',
				multiline: true,
				minRows: 3
			};
			break;
	}

	const maxLengthProps = maxLength
		? {
				inputProps: {
					maxLength: maxLength,
					disableUnderline: true
				},
				helperText: `${answerString.length}/${maxLength} characters`
			}
		: {};

	return inEditMode ? (
		<></>
	) : (
		<>
			<TextField
				{...textFieldProps}
				{...maxLengthProps}
				onChange={c => {
					if (formRenderMode === FormRenderMode.design) return;
					if (maxLength && c.target.value.length > maxLength) return;

					answerQuestion({
						answer: {
							answerString: c.target.value
						},
						questionName: questionName
					});
				}}
				placeholder={placeholder}
				value={answerString}
				sx={{
					'.MuiInputBase-root': {
						color,
						fontSize,
						fontStyle,
						fontFamily,
						textDecoration,
						fontWeight
					},
					'input:focus, textarea': {
						border: '0',
						boxShadow: 'none'
					}
				}}
			/>
		</>
	);
};
